<!--
   Created by qing on 2020/5/4
   Des:
-->
<template>
  <div class="form-view-data-detail" v-wechat-title="formName">
    <FormViewDataDetail
      ref="formViewDataDetail"
      :viewType="1"
      :formId="formId"
      :isLink="Boolean(isLink)"
      :btnId="btnId"
      @saveFormDataComplete="saveFormDataComplete">
    </FormViewDataDetail>
  </div>
</template>

<script>
  import FormViewDataDetail from "../component/FormViewDataDetail"
  import ViewSet from "../RyView";
  import {FORM_TYPE__FILL} from "../RyForm/types";
  import {SUCCESS} from "../store/types";

  export default {
    components: {
      FormViewDataDetail
    },
    beforeRouteLeave(to, form, next) {
      if (this.$refs.formViewDataDetail) {
        let exit = true
        Object.keys(this.$refs.formViewDataDetail.formSet.fields).forEach(fieldId => {
          const field = this.$refs.formViewDataDetail.formSet.fields[fieldId]
          if (field && field.showContact) {
            field.showContact = false
            exit = false
          }
        })

        if (this.$refs.formViewDataDetail.chargeUserConfig.showContact) {
          this.$refs.formViewDataDetail.chargeUserConfig.showContact = false
          exit = false
        }

        if (this.$refs.formViewDataDetail.atUserConfig.showContact) {
          this.$refs.formViewDataDetail.atUserConfig.showContact = false
          exit = false
        }
        if (exit) {
          next()
        } else {
          next(false)
        }

        // if (this.$refs.formViewDataDetail.formSet.showContact) {
        //   this.$refs.formViewDataDetail.formSet.showContact = false
        //   next(false)
        // } else {
        //   next()
        // }
      } else {
        next()
      }
    },
    data() {
      return {
        formName: '',
        instanceId: '',
        showFields: [],
        stepId: '',
        viewId: '',
        formId: '',
        index: 0,
        dataList: [],
        tabActive: '',
        logTabActive: '',
        isLink: false,
        hiddenDynamic: 0,
        hiddenEdit: 0,
        hiddenPrint: 0,
        hiddenMore: 0,
        btnId: ''
      }
    },
    created() {
    },
    mounted() {

      const toast = this.$toast.loading({
        message: '加载中...'
      })
      this.$store.dispatch('actionWechatNodeGet', this.$route.query.key)
        .then(res => {
          this.instanceId = res.instanceId
          this.showFields = res.showFields
          this.stepId = res.stepId
          this.viewId = res.viewId
          this.formId = res.formId
          this.index = res.index
          this.dataList = res.dataList
          this.tabActive = res.tabActive
          this.logTabActive = res.logTabActive
          this.isLink = res.isLink
          this.btnId = res.btnId
          this.hiddenEdit = res.hasOwnProperty('hiddenEdit') ? res.hiddenEdit : 0
          this.hiddenPrint = res.hasOwnProperty('hiddenPrint') ? res.hiddenPrint : 0
          this.hiddenMore = res.hasOwnProperty('hiddenMore') ? res.hiddenMore : 0
          this.hiddenDynamic = res.hasOwnProperty('hiddenDynamic') ? res.hiddenDynamic : 0
          if (res.isLink) {
            return {}
          } else {
            if (this.$store.state.userId === 1) {
              return this.$store.dispatch('actionFetchFormViewOutDetail', {
                companyId: this.$store.state.companyId,
                appId: this.$store.state.appId,
                formId: res.formId,
                viewId: res.viewId
              })
            } else {
              return this.$store.dispatch('actionFetchFormViewDetail', {
                formId: res.formId,
                viewId: res.viewId
              })
            }
          }
        })
        .then(resultObject => {

          this.$store.dispatch('actionMergeStructure', {
            formId: this.formId,
            formType: FORM_TYPE__FILL,
            viewType: 0,
          })
            .then(({status, resultObject, info}) => {
              if (status === SUCCESS) {
                this.formName = resultObject.detailInfo.formName
                this.$store.dispatch('setPageTitle', this.formName)
              } else {
                throw new Error(`${status}: ${info}`)
              }
            })

          if (this.$refs.formViewDataDetail) {
            this.$refs.formViewDataDetail.open({
              instanceId: this.instanceId,
              stepId: this.stepId,
              viewId: this.viewId,
              showFields: this.showFields,
              index: this.index,
              dataList: this.dataList,
              canEdit: !resultObject.forbiddenEdit,
              isShowLog: resultObject.showFlowLog !== 'NO',
              isDynamic: resultObject.showHistory !== 'NO',
              showApply: resultObject.showApproval !== 'NO',
              showComment: resultObject.showComment !== 'NO',
              readonlyFields: resultObject.notAllowEditFieldList,
              readonlyAll: resultObject.dataReadOnly,
              tabActive: this.tabActive,
              logTabActive: this.logTabActive,
              hiddenDynamic: this.hiddenDynamic,
              hiddenEdit: this.hiddenEdit,
              hiddenPrint: this.hiddenPrint,
              hiddenMore: this.hiddenMore,
              allowDelete: resultObject.allowDelete
            })
          }
        })
        .then(() => {
          return this.$store.dispatch('getAppDetail', {
            appId: this.$store.getters.currentAppId
          })
        })
        .then(resultObject => {
          if (resultObject) {
            this.$store.commit('UPDATE__APP', resultObject)
          } else {
            this.$toast.fail('应用不存在，请退出重试')
          }
        })
        .catch(console.error)
        .finally(() => {
          toast.clear()
        })
    },
    methods: {

      // 保存修改了数据视图
      saveFormDataComplete(viewId) {
        this.$router.go(-1)
      }
    },
    inject: ['reload'],
    watch: {
      '$route.query.key'() {
        this.reload()
      }
    }
  }
</script>

<style lang="less">

  .form-view-data-detail {
    height: calc(100% - env(safe-area-inset-bottom));
  }
</style>
